export const UPLOAD_ZONE_MAPPING_SUCCESS = 'UPLOAD_ZONE_MAPPING_SUCCESS';
export const UPLOAD_ZONE_MAPPING_REQUEST = 'UPLOAD_ZONE_MAPPING_REQUEST';
export const UPLOAD_ZONE_MAPPING_FAILURE = 'UPLOAD_ZONE_MAPPING_FAILURE';
export const UPLOAD_ZONE_MAPPING_REST = 'UPLOAD_ZONE_MAPPING_REST';
export const uploadZoneMappingSuccess = (payload) => ({
    type: UPLOAD_ZONE_MAPPING_SUCCESS,
    payload,
});
export const uploadZoneMappingRequest = (payload) => ({
    type: UPLOAD_ZONE_MAPPING_REQUEST,
    payload,
});
export const uploadZoneMappingFailure = (payload) => ({
    type: UPLOAD_ZONE_MAPPING_FAILURE,
    payload,
});
export const uploadZoneMappingRest = () => ({
    type: UPLOAD_ZONE_MAPPING_REST,
});
